// extracted by mini-css-extract-plugin
module.exports = {"iconstyle":"icons_iconstyle__3TluJ","iconstyle2":"icons_iconstyle2__1zcfS","linkStyle":"icons_linkStyle__26v5z"};